exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1tlqm {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.OUhwN {\n  text-transform: capitalize;\n}\n", ""]);

// Exports
exports.locals = {
	"headerRow": "_1tlqm",
	"header": "OUhwN"
};